import React from "react";

//import partner images
import amazon from "../../assets/images/client/amazon.svg";
import google from "../../assets/images/client/google.svg";
import lenovo from "../../assets/images/client/lenovo.svg";
import paypal from "../../assets/images/client/paypal.svg";
import shopify from "../../assets/images/client/shopify.svg";
import spotify from "../../assets/images/client/spotify.svg";
import feature1 from "../../assets/images/client/feature1.svg";
import feature2 from "../../assets/images/client/feature2.svg";
import feature3 from "../../assets/images/client/feature3.svg";
import feature4 from "../../assets/images/client/feature4.svg";
import feature5 from "../../assets/images/client/feature5.svg";

const Partners = () => { 
      const partners = [
        {
          id: 1,
          img: feature1,
        },
        {
          id: 2,
          img: feature2,
        },
        {
          id: 3,
          img: feature3,
        },
        {
          id: 4,
          img: feature4,
        },
        {
          id: 5,
          img: feature5,
        },
      ];
    
    return (
      <React.Fragment>
        <section className="py-4 border-top bg-light">
          <div className="container">
            <div className="row justify-content-center">
              {partners.map((partners, key) => (
                <div
                  className="col-lg-2 col-md-2 col-6 text-center py-4"
                  key={key}
                >
                  <img
                    src={partners.img}
                    className="avatar avatar-ex-sm"
                    alt=""
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
      </React.Fragment>
    );  
}; 
export default Partners;
